import appConfig from "@/config/appConfig";
import { Spin } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import { numberFormater } from "@/utils";

const ViewAssingedSubscription = () => {
  const [isLoading, setLoading] = useState(false);
  const Params = useParams();
  const planId = Params.planId;
  const [prepaidPlanDetails, setprepaidPlanDetails] = useState();
  const [utilisation, setUtilisation] = useState({});
  const navigate = useNavigate();

  const getPrepaidPlan = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/subscription/utilisation-details/` + planId, {
        withCredentials: true,
      });
      if (response) {
        setprepaidPlanDetails(response.data?.subscription || {});
        setUtilisation(response?.data?.utilisation || {});
      }
    } finally {
      setLoading(false);
    }
  };

  const upgradePlanReq = async () => {
    Swal.fire({
      title: "Do you wish to upgrade your plan?",
      text: "This action will send a message to the administrator.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.get(`/subscription/upgrade-plan/` + planId, {
            withCredentials: true,
          });
          Swal.fire({
            title: "Done!",
            text: "Your request has been sent to the administrator. They will reach out shortly.",
            icon: "success",
            timer: 2000,
            confirmButtonText: "OK",
          });
        } catch {
          Swal.fire({
            title: "",
            text: "Something went wrong.",
            icon: "error",
            timer: 2000,
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  useEffect(() => {
    document.title = appConfig.name + " - Subscription Plan Details";
    getPrepaidPlan();
  }, []);

  return (
    <Spin spinning={isLoading}>
      <div className="az-content-body p-0 px-md-3">
        <div className="row row-sm mg-b-15 mg-sm-b-20">
          <div className="col-lg-12">
            <div className="card card-dashboard-six">
              <div className="card-header">
                <div className="col-md-8 p-0">
                  <label className="az-content-label">Manage Subscription Plan</label>
                  <span className="d-block py-2">Subscription Plan Details</span>
                </div>
                <div className="col-md-4 d-flex justify-content-end p-0"></div>
              </div>
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="az-content-label">General Information</label>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Plan Name</div>
                    <div className="col-7">: {prepaidPlanDetails?.name || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Plan Type</div>
                    <div className="col-7">: {prepaidPlanDetails?.planType || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Type</div>
                    <div className="col-7">: {prepaidPlanDetails?.subscriptionType || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Currency</div>
                    <div className="col-7">: {prepaidPlanDetails?.currency || "N/A"}</div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Subscription Price</div>
                    <div className="col-7">
                      : {prepaidPlanDetails?.price ? numberFormater(prepaidPlanDetails?.price) : "N/A"}
                      {prepaidPlanDetails?.duration && ` / ${prepaidPlanDetails.duration}`}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">SMS Balance</div>
                    <div className="col-7">: {prepaidPlanDetails?.smsCount ? prepaidPlanDetails.smsCount : 0}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <label className="az-content-label">Plan Limitations</label>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Admin Users</div>
                    <div className="col-7">
                      : {utilisation?.totalSiteAdmin || 0}/{prepaidPlanDetails?.siteAdminCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Users</div>
                    <div className="col-7">
                      : {utilisation?.totalSiteUsers || 0}/{prepaidPlanDetails?.siteUserCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Site Public Users</div>
                    <div className="col-7">
                      : {utilisation?.totalPublicUsers || 0}/{prepaidPlanDetails?.sitePublicCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Installer Users</div>
                    <div className="col-7">
                      : {utilisation?.totalInstallers || 0}/{prepaidPlanDetails?.installerCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Locations</div>
                    <div className="col-7">
                      : {utilisation?.totalSiteLocation || 0}/{prepaidPlanDetails?.locationCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Devices</div>
                    <div className="col-7">
                      : {utilisation?.totalDevices || 0}/{prepaidPlanDetails?.deviceCount || 0}
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-5">Total Dashboards</div>
                    <div className="col-7">
                      : {utilisation?.totalDashboard || 0}/{prepaidPlanDetails?.dashboardCount || 0}
                    </div>
                  </div>
                  {/* <div className="row mb-2">
                    <div className="col-5">Total Hosting Year</div>
                    <div className="col-7">: {prepaidPlanDetails?.storageCount || 0}</div>
                  </div> */}
                  <div className="row mb-2">
                    <label className="az-content-label d-block mt-3 mb-2">Premium Features</label>
                    <div className="col-5">Custom Reports</div>
                    <div className="col-7">: {prepaidPlanDetails?.isCustomerReportAllow ? "Yes" : "No"}</div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 d-flex justify-content-end">
                  <button className="btn btn-success me-1" onClick={upgradePlanReq}>
                    Upgrade Plan
                  </button>
                  <button onClick={() => navigate(-1)} className="btn btn-secondary">
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default ViewAssingedSubscription;
